type NavigationIntent = { to: string; replace: boolean; noSearchParam: boolean }
type LoadKind = "billingPlan" | "openCounts"
type LoadIntent = { kind: LoadKind; key: string; payload: { orgId: string } }
type ResetIntent = { kind: LoadKind }

export type OrgaViewAutomationPlan = {
  nextDefaultPath: string | null
  loads: LoadIntent[]
  resets: ResetIntent[]
  navigate?: NavigationIntent
  accessNotice?: string
}

export type OrgaViewAutomationSnapshot = {
  defaultPath: string | null
  apiOrganizationId: string | null
  normalizedPath: string
  canViewNotifications: boolean
  billingAvailable: boolean
  workOrdersPath: string
  workOrdersNavigationPath: string | null
}

/** Data lifecycle and the operative scheduling guard; administration owns its own routes. */
export const buildOrgaViewAutomationPlan = (
  snapshot: OrgaViewAutomationSnapshot,
): OrgaViewAutomationPlan => {
  const loads: LoadIntent[] = []
  const resets: ResetIntent[] = []
  const orgId = snapshot.apiOrganizationId

  if (!orgId || !snapshot.billingAvailable) resets.push({ kind: "billingPlan" })
  else loads.push({ kind: "billingPlan", key: orgId, payload: { orgId } })

  if (!orgId || !snapshot.canViewNotifications) resets.push({ kind: "openCounts" })
  else loads.push({ kind: "openCounts", key: orgId, payload: { orgId } })

  if (
    snapshot.workOrdersPath &&
    !snapshot.workOrdersNavigationPath &&
    (snapshot.normalizedPath === snapshot.workOrdersPath ||
      snapshot.normalizedPath.startsWith(`${snapshot.workOrdersPath}/`)) &&
    snapshot.defaultPath &&
    snapshot.defaultPath !== snapshot.normalizedPath
  ) {
    return {
      nextDefaultPath: snapshot.defaultPath,
      loads,
      resets,
      navigate: { to: snapshot.defaultPath, replace: true, noSearchParam: true },
      accessNotice: "Für diesen Auftrags- oder Kalenderbereich fehlt Ihnen die Berechtigung.",
    }
  }

  return { nextDefaultPath: snapshot.defaultPath, loads, resets }
}
